import EditBlogPost from "./EditBlogPost";

export default EditBlogPost;